import { Colors, Flex, useSafeArea, type ListRef } from '@banhala/ui-kit';
import Svg, { Path, Rect } from 'react-native-svg';
import Animated, {
  interpolate,
  useAnimatedStyle,
  type SharedValue,
} from 'react-native-reanimated';
import { Pressable } from 'react-native';
import type { RefObject } from 'react';
import type { IScreensComponent } from '../../../api';

export const ScrollToTopButton: React.FC<{
  atomicRendererScrollY: SharedValue<number>;
  listRef: RefObject<ListRef<IScreensComponent> | null>;
}> = ({ atomicRendererScrollY, listRef }) => {
  const { bottom } = useSafeArea();

  // const { scrollY, listRef } = useContext(ScrollContext);
  const style = useAnimatedStyle(() => {
    return {
      width: 40,
      height: 40,
      borderRadius: 20,
      shadowColor: Colors.overlay_dark,
      shadowOffset: {
        width: 0,
        height: 1,
      },
      shadowOpacity: 0.12,
      shadowRadius: 1.41,

      elevation: 2,
      transform: [
        {
          translateY: interpolate(
            atomicRendererScrollY.value,
            [0, 300, 310],
            [100, 100, 0],
            'clamp',
          ),
        },
      ],
    };
  });

  return (
    <Flex position={'absolute'} right={16} bottom={16 + bottom}>
      <Animated.View style={style}>
        <Pressable
          pointerEvents={'box-only'}
          onPress={() => {
            listRef?.current?.scrollToOffset({ offset: 0, animated: true });
          }}
        >
          <Svg width="40" height="40" viewBox="0 0 40 40" fill="none">
            <Rect
              x="0.5"
              y="0.5"
              width="39"
              height="39"
              rx="19.5"
              fill="white"
            />
            <Rect
              x="0.5"
              y="0.5"
              width="39"
              height="39"
              rx="19.5"
              stroke="#EEEEEE"
            />
            <Path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.1677 25.7121V16.4037L15.101 20.4704C14.776 20.7954 14.2427 20.7954 13.9177 20.4704C13.5927 20.1454 13.5927 19.6204 13.9177 19.2954L19.4094 13.8037C19.7344 13.4787 20.2594 13.4787 20.5844 13.8037L26.0844 19.2871C26.4094 19.6121 26.4094 20.1371 26.0844 20.4621C25.7594 20.7871 25.2344 20.7871 24.9094 20.4621L20.8344 16.4037V25.7121C20.8344 26.1704 20.4594 26.5454 20.001 26.5454C19.5427 26.5454 19.1677 26.1704 19.1677 25.7121Z"
              fill="#9E9E9E"
            />
          </Svg>
        </Pressable>
      </Animated.View>
    </Flex>
  );
};
